import { Injectable, inject } from '@angular/core';
import {
  DvDialogComponent,
  DvDialogOptions,
  DvDialogService2,
} from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DialogService {
  private dialog = inject(DvDialogService2);
  private translate = inject(TranslateService);

  open<TData, TContentComponent>(
    options: DvDialogOptions<TData, TContentComponent>
  ): DvDialogComponent<TData, TContentComponent> {
    return this.dialog.open<TData, TContentComponent>(
      this.translateDialogOptions(options)
    );
  }

  closeAllDialogs(): void {
    this.dialog.getOpenDialogRefs().forEach(dialog => {
      dialog.instance.onClose();
    });
  }

  private translateDialogOptions(options: DvDialogOptions): DvDialogOptions {
    return {
      ...options,
      hideTransparent: true,
      confirmText: this.translate.instant(
        options.confirmText ? options.confirmText : 'General.Save'
      ),
      cancelText: options.cancelText
        ? this.translate.instant(options.cancelText)
        : '',
      contentText: options.contentText
        ? this.translate.instant(options.contentText)
        : undefined,
      title: options.title ? this.translate.instant(options.title) : undefined,
      subTitle: options.subTitle
        ? this.translate.instant(options.subTitle)
        : undefined,
    };
  }
}
